import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public')({
  component: _Public,
});

function _Public() {
  return <Outlet />;
}
